
import React from 'react';
import './Footer.scss';
import termsData from './data.json';

type TermsContentItem =
  | { type: 'paragraph'; content: string }
  | { type: 'copyright'; content: string };

const renderTermsContent = (content: TermsContentItem[]) => {
  return content.map((item: TermsContentItem, idx: number) => {
    switch (item.type) {
      case 'paragraph':
        return <p key={idx}>{item.content}</p>;
      case 'copyright':
        return <p key={idx} style={{ color: 'gray', marginTop: '2rem' }}>{item.content}</p>;
      default:
        return null;
    }
  });
};

const TermsContent: React.FC = () => (
  <div className="terms-content" >
    {renderTermsContent(termsData.terms.content as TermsContentItem[])}
  </div>
);

export default TermsContent;
